/**
 * SanitizedHtml — rendering sicuro di corpi email HTML (Gmail/Outlook).
 * Estratto da MailThreadView.tsx (Task 12): stessa config DOMPurify, stessa
 * classe `gmail-html`. Nessun cambio di comportamento rispetto all'originale.
 */

import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

interface SanitizedHtmlProps {
  html: string;
  className?: string;
}

export function SanitizedHtml({ html, className }: SanitizedHtmlProps) {
  const sanitized = useMemo(() => DOMPurify.sanitize(html, {
    // Tag/attributi ampi per rendere fedelmente l'HTML delle email (colori, tabelle, immagini)
    ALLOWED_TAGS: [
      'p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'strike', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code', 'img', 'div', 'span',
      'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'caption', 'colgroup', 'col',
      'hr', 'sup', 'sub', 'small', 'font', 'center', 'figure', 'figcaption', 'address',
    ],
    ALLOWED_ATTR: [
      'href', 'src', 'srcset', 'alt', 'title', 'style', 'class', 'target', 'rel',
      'width', 'height', 'colspan', 'rowspan', 'align', 'valign', 'bgcolor', 'color',
      'face', 'size', 'border', 'cellpadding', 'cellspacing', 'dir', 'background',
    ],
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
  }), [html]);

  return (
    <div
      // NB: niente `prose` qui — sovrascriverebbe i colori/spaziature inline delle email.
      // Lasciamo che l'HTML dell'email si renda con i propri stili.
      className={`gmail-html text-sm leading-relaxed text-[#37352F] dark:text-white/80 [&_img]:max-w-full [&_img]:h-auto [&_a]:text-[#2383E2] [&_a]:underline [&_table]:max-w-full${className ? ` ${className}` : ''}`}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
